module.exports = __webpack_public_path__ + "assets/img/teacher (4).182e8557.png";